<template>
  <div class="circle-progress-component-container">
    <svg
      viewBox="0 0 100 100"
      :style="{strokeWidth: `${thickness}%`}"
    >
      <circle
        :r="radius"
        cx="50"
        cy="50"
        :stroke-dasharray="circumference"
        stroke-dashoffset="0"
      />
      <circle
        :r="radius"
        cx="50"
        cy="50"
        :stroke-dasharray="circumference"
        stroke-dashoffset="0"
        transform="rotate(270, 50, 50)"
        :style="{strokeDashoffset: offset, strokeLinecap: cap}"
      />
    </svg>
    <div
      :style="{height: innerStyles['height'], width: innerStyles['width'], top: innerStyles['top'], left: innerStyles['left']}"
      class="inner"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numerator: {
      type: Number,
      default: 0,
    },
    denominator: {
      type: Number,
      default: 0,
    },
    cap: {
      type: String,
      default: 'round',
    },
    thickness: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    circumference() {
      return this.radius * Math.PI * 2;
    },
    offset() {
      return `${(1 - (this.numerator / (this.denominator || 1))) * this.circumference}px`;
    },
    innerStyles() {
      let side = (100 - (this.thickness * 2)) / Math.sqrt(2);
      return {
        height: `${side}%`,
        width: `${side}%`,
        top: `${(100 - side) / 2}%`,
        left: `${(100 - side) / 2}%`,
      };
    },
    radius() {
      return 50 - (this.thickness / 2);
    },
  },
};
</script>
<style lang='scss' scoped>
.circle-progress-component-container {
  border-radius: 100%;
  position: relative;
  margin: auto;

  svg {
    height: 100%;
    width: 100%;

    :deep(circle) {
      fill: transparent;
      stroke-dashoffset: 0;
      stroke: #E6F4FA;
      transition: stroke-dashoffset 1s linear;

      &:last-child {
        stroke: #45B0D9;
      }
    }
  }

  .inner {
    border-radius: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    :slotted(.percent) {
      color: #354052;
      font-size: rem-calc(24);
      font-weight: $bold;
      margin-bottom: rem-calc(4);
    }

    :slotted(.correct) {
      color: #354052;
    }

    :slotted(.earned) {
      color: #8B929B;
      font-size: rem-calc(8);
    }

    :slotted(.fraction) {
      color: #53606e;
      font-weight: $semi-bold;
      margin-bottom: rem-calc(2);
    }
  }
}
</style>
